import React from "react";
import { Button, ArrowDownIcon, ChevronDownIcon } from "@fluentui/react-northstar";
import pl from "shared/messages/pl";
import styles from "./notesListShowMoreButton.module.scss";

export interface NotesListShowMoreButtonProps {
    isLoading: boolean;
    onClick: () => void;
}

const NotesListShowMoreButton: React.FC<NotesListShowMoreButtonProps> = (props) => {
    return (
        <Button
            text
            iconPosition="after"
            icon={<ChevronDownIcon />}
            fluid
            content={
                props.isLoading
                    ? pl.view360Card.notes.notesList.loading
                    : pl.view360Card.notes.notesList.showMoreNotes
            }
            loading={props.isLoading}
            disabled={props.isLoading}
            onClick={props.onClick}
            className={props.isLoading ? undefined : styles.button}
        />
    );
};

export default NotesListShowMoreButton;
